import React from 'react'
import Datetime from 'react-datetime'
import isEqual from 'lodash/fp/isEqual'

export default class PureDatetimeWrapper extends React.Component<Datetime.DatetimepickerProps> {
  shouldComponentUpdate(nextProps: any) {
    const { value: nextValue, ...nextRest } = nextProps
    const { value, ...rest } = this.props

    if (!isEqual(rest, nextRest)) {
      return true
    }

    return !nextProps.value.isSame(this.props.value)
  }

  render() {
    return <Datetime {...this.props} />
  }
}
